






import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "TabPane",
  props: {
    name: {
      type: [String, Number] as PropType<Props["name"]>,
      required: true
    }
  },
  computed: {
    active() {
      const active = (this.$parent as any)._props.value === this.name;
      return active;
    }
  }
});
